export default __webpack_public_path__ + "static/077-a35dc34db6e375d83723a1110c6dbc09.jpg";